var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',{staticClass:"booking-details-title"},[_vm._v("RO Produs Hello Holidays")]),_c('b-card',{attrs:{"bg-variant":"light"}},[_c('b-card-text',[_vm._v(" Conditii ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }